import React from 'react';
import { CGE } from '../../../../common/components/CGE';
import AlertModal from "../../../../common/components/AlertModal";

function RecoverPasswordSecondStep({props}) {
  return (
    <div>
        <CGE.Panel title={props?.title_get_password2}>
            <CGE.PanelSectionTicket title={props?.description_get_password2}>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => props?.setValues({ ...props?.values, code: e.target.value })}
                        idFormElement="code"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Código:"
                        labelStyle={{ fontSize: "14px"  }}
                        typeElement="input"
                        hasError={props?.inputValidateSecond?.empty?.code}
                        msgError={props?.inputValidateSecond?.msg?.code}
                        value={props?.values?.code}
                        maxLength={50}
                        
                    />
                </CGE.PanelContainer>
            </CGE.PanelSectionTicket>
            <CGE.PanelSectionTicket title={props.title_section_cambio_contrasena_2}>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => 
                            {
                                props?.setValues({ ...props?.values, newPassword: e.target.value });
                                props?.checkPasswordFunc(e.target.value);
                            }

                        }
                        idFormElement="newPassowrd"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Contraseña Nueva:"
                        labelStyle={{ fontSize: "14px"  }}
                        style={{ "-webkit-text-security" : "disc" }}
                        typeElement="input"
                        hasError={props?.inputValidateSecond?.empty?.newPassword}
                        msgError={props?.inputValidateSecond?.msg?.newPassword}
                        value={props?.values?.newPassword}
                        typeFormElement="text"
                        
                    />
                </CGE.PanelContainer>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => props?.setValues({ ...props?.values, confirmNewPassowrd: e.target.value })}
                        idFormElement="confirmNewPassowrd"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Confirmar Contraseña Nueva:"
                        labelStyle={{ fontSize: "14px"  }}
                        typeElement="input"
                        hasError={props?.inputValidateSecond?.empty?.confirmNewPassowrd}
                        msgError={props?.inputValidateSecond?.msg?.confirmNewPassowrd}
                        value={props?.values?.confirmNewPassowrd}
                        style={{ "-webkit-text-security" : "disc" }}
                        typeFormElement="text"
                        
                    />
                </CGE.PanelContainer>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="sm"
                >
                    <div className="d-flex flex-column">
                        <CGE.FieldCheckPassowd
                            checked={props?.checkPassword?.lowerCase}
                            labelName={props.condition_cambio_contrasena_1}
                        />
                        <CGE.FieldCheckPassowd
                            checked={props?.checkPassword?.upperCase}
                            labelName={props.condition_cambio_contrasena_2}
                        />
                        <CGE.FieldCheckPassowd
                            checked={props?.checkPassword?.containsNumber}
                            labelName={props.condition_cambio_contrasena_3}
                        />
                        <CGE.FieldCheckPassowd
                            checked={props?.checkPassword?.minLength}
                            labelName={props.condition_cambio_contrasena_4}
                        />
                    </div>
          
                </CGE.PanelContainer>

            </CGE.PanelSectionTicket>
            <div className="d-flex justify-content-between">
                <CGE.Button
                    label="Volver"
                    onClick={() => {
                            props?.setPage(0);
                            props?.setValues({ ...props?.values, code: '', newPassword: '', confirmNewPassowrd: ''})
                            props?.setCheckPassword({ ...props?.checkPassword, lowerCase: false, upperCase: false, containsNumber: false, minLength: false})
                        }
                    }
                    type="secondary"
                />
                <CGE.Button
                    label="Aceptar"
                    onClick={() => props?.handleClickSecondStep()}
                />
            </div>
        </CGE.Panel>

        {props.visibleModalConfirmAceptar && (
            <AlertModal
                observer={props.observer}
                onClose={props.onClose}
                msgModal="¡Contraseña alterada con éxito!"
                status="success"
                funcClick={() => {
                    window.open(`/web/guest/oficina-virtual`, '_self');
                    props.onClose();
                }}
                btnCancel={false}
                labelBtnConfirm={"Ok"}
                confirm={true}
            />
        )}
    </div>
  )
}

export default RecoverPasswordSecondStep;